import PropTypes from 'prop-types';

// Estilos
import estilos from './labelMenu.module.css';
import { HREF, PAGES, TEXT } from '../../../utils/varGlobal';
import { useEffect, useState } from 'react';
import GoBack from '../misc/goBack';


function LabelMenu(props){

    let [texto, setTexto] = useState(null);
    let [enlace, setEnlace] = useState(null);
    let [estilo, setEstilo] = useState(null);

    useEffect(() => {
        switch (props.opcion){
            case 'contact':
                setTexto(TEXT.menu.CONTACT);
                setEnlace(PAGES.CONTACT);
                setEstilo(estilos.etiquetaContact);
                break;
            case 'work':
                setTexto(TEXT.menu.WORK);
                setEnlace(PAGES.WORK);
                setEstilo(estilos.etiquetaWork);
                break;
            case 'about':
                setTexto(TEXT.menu.ABOUT_US);
                setEnlace(PAGES.ABOUT_US);
                setEstilo(estilos.etiquetaAboutUs);
                break;
            case 'instagram':
                setTexto(TEXT.menu.INSTAGRAM);
                setEnlace(HREF.INSTAGRAM);
                setEstilo(estilos.etiquetaInstagram);
                break;
            default:
                break;
        }
    }, []); // eslint-disable-line

    return (
    <div className={estilos.etiqueta} id={estilo}>
        <GoBack enabled={props.goBack}/>
        <a href={enlace}>{texto}</a>
    </div>);
}

LabelMenu.propTypes = {
    goBack : PropTypes.bool,
    opcion : PropTypes.string
}

export default LabelMenu;